export const CancelProgress = ({ row }) => {
  return (
    <div className="queue-table__loading cancel" style={{ backgroundColor: row.statusName.color }}>
      {row.statusName.label}
    </div>
  );
};
